import { PopoverPlacement } from "@idui/react-popover";
import { PlaylistAddCheck } from "@mui/icons-material";
import { Button } from "@mui/material";
import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip } from "@ryde/controls";
import { TOOLTIP_DELAY_BUTTONS, useIsMobile } from "@ryde/shared";

import { SelectedRowsToggleWrapper } from "./header-selected-rows-toggle.styled";
import { useSelectedRowsToggle } from "./use-selected-rows-toggle";

export const HeaderSelectedRowsToggle: FC = () => {
  const { isMobile } = useIsMobile();
  const { t } = useTranslation();
  const { isActive, selectedCount, handleToggle } = useSelectedRowsToggle();

  return (
    <SelectedRowsToggleWrapper>
      <FramerTooltip
        content={t("selectListLabel.ShowSelectedOnly")}
        placement={PopoverPlacement.top}
        mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
      >
        <Button
          className={clsx("selected-rows-button", { active: isActive })}
          variant="outlined"
          size={isMobile ? "small" : "large"}
          onClick={handleToggle}
          aria-pressed={isActive}
        >
          <PlaylistAddCheck className="selected-rows-icon" />
          <strong>{selectedCount}</strong>
        </Button>
      </FramerTooltip>
    </SelectedRowsToggleWrapper>
  );
};
